import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  AssignmentCustomerResponse,
  AssignmentDateListItemResponse,
  baseAssignmentsActions,
  baseAssignmentsSelectors,
  BaseButtonSize,
  BaseCoreState,
} from 'base';
import { Store } from '@ngrx/store';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'base-customer-employee-time-recordings-tab',
  templateUrl: './base-customer-employee-time-recordings-tab.component.html',
})
export class BaseCustomerEmployeeTimeRecordingsTabComponent implements OnInit, OnDestroy {
  @Input() assignment: AssignmentCustomerResponse;
  buttonSize = BaseButtonSize;
  assignmentDates: AssignmentDateListItemResponse[] = [];
  private destroy$ = new Subject();

  constructor(private store: Store<BaseCoreState>) {}

  ngOnInit() {
    if (!this.assignment) {
      return;
    }
    this.store.dispatch(baseAssignmentsActions.loadAssignmentDates({ payload: { assignment: this.assignment.id } }));

    this.store
      .select(baseAssignmentsSelectors.getAssignmentDates)
      .pipe(
        takeUntil(this.destroy$),
        filter((assignmentDatesState) => assignmentDatesState.ok),
        map((state) => state.data?.data)
      )
      .subscribe((assignmentDates) => (this.assignmentDates = assignmentDates));
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
